import { useState, useRef, useEffect } from 'react';
import './Testimonials.css';
import TestimonialsBento from '../components/ui/testimonial';

const testimonials = [
  {
    name: 'Thiyagavivek',
    role: 'Founder, Putchi',
    bg: '#ffffff', color: '#0d0d0d',
    quote: '"Aurelix didn\'t skim the surface. They asked the right questions, went deep on the technical side, and delivered work that most teams would have missed entirely. Technically excellent, genuinely collaborative — a team I\'d work with again without hesitation."',
  },
  {
    name: 'Artkart Founder',
    role: 'Artkart',
    bg: '#ffccb9ff', color: '#000000ff',
    quote: '"Rare combination of technical depth and creative sensibility. They understood our brand from day one and delivered a platform that truly reflects it. Professional, proactive, detail-oriented."',
  },
  {
    name: 'Aditya',
    role: 'Founder, NuboKind (London)',
    bg: '#b8d8c8', color: '#0d0d0d',
    quote: '"Helped us build and run our Meta Ads from scratch. Great strategic thinking, sharp execution. Exactly the kind of growth partner you want."',
  },
];

// duplicate for seamless loop
const CARDS = [...testimonials, ...testimonials];

export default function Testimonials() {
  const trackRef = useRef(null);
  const rafRef = useRef(null);
  const posRef = useRef(0);
  const pausedRef = useRef(false);
  const SPEED = 0.6; // px per frame
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 768);
  
  // refs for manual drag on mobile
  const dragStartX = useRef(0);
  const isDragging = useRef(false);
  const startPosRef = useRef(0);

  // Update isMobile on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // auto-scroll loop for mobile marquee
  useEffect(() => {
    if (!isMobile) return;
    const track = trackRef.current;
    if (!track) return;

    const halfW = track.scrollWidth / 2;
    let timeoutId = null;

    const startScroll = () => {
      const tick = () => {
        if (!pausedRef.current && !isDragging.current && track) {
          posRef.current += SPEED;
          if (posRef.current >= halfW) posRef.current -= halfW;
          track.style.transform = `translateX(-${posRef.current}px)`;
        }
        rafRef.current = requestAnimationFrame(tick);
      };
      rafRef.current = requestAnimationFrame(tick);
    };

    timeoutId = setTimeout(startScroll, 1000);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [isMobile]);

  return (
    <section className="tm-section" id="testimonials">
      {isMobile ? (
        /* ── MOBILE MARQUEE VIEW (Preserved exactly) ── */
        <>
          <div className="tm-header">
            <span className="tm-label">Client Stories</span>
            <h2 className="tm-title">
              What our clients <span className="tm-accent">say about us.</span>
            </h2>
          </div>

          <div className="tm-stage tm-stage--expanded">
            <div
              className="tm-marquee-wrap"
              onMouseEnter={() => { pausedRef.current = true; }}
              onMouseLeave={() => { pausedRef.current = false; }}
            >
              <div 
                className="tm-track" 
                ref={trackRef}
                onTouchStart={(e) => {
                  isDragging.current = true;
                  dragStartX.current = e.touches[0].clientX;
                  startPosRef.current = posRef.current;
                  pausedRef.current = true;
                }}
                onTouchMove={(e) => {
                  if (!isDragging.current) return;
                  const delta = e.touches[0].clientX - dragStartX.current;
                  posRef.current = startPosRef.current - delta;
                  if (posRef.current < 0) posRef.current += trackRef.current.scrollWidth / 2;
                  if (posRef.current > trackRef.current.scrollWidth / 2) posRef.current -= trackRef.current.scrollWidth / 2;
                  trackRef.current.style.transform = `translateX(-${posRef.current}px)`;
                }}
                onTouchEnd={() => {
                  isDragging.current = false;
                  pausedRef.current = false;
                }}
              >
                {CARDS.map((t, i) => (
                  <div
                    key={i}
                    className="tm-card"
                    style={{ background: t.bg, color: t.color }}
                  >
                    <p className="tm-quote">{t.quote}</p>
                    <div className="tm-person">
                      <div className="tm-avatar" style={{ background: t.color === '#ffffff' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)' }}>
                        {t.name[0]}
                      </div>
                      <div>
                        <p className="tm-name" style={{ color: t.color }}>{t.name}</p>
                        <p className="tm-role" style={{ color: t.color === '#ffffff' ? 'rgba(255,255,255,0.6)' : 'rgba(13,13,13,0.55)' }}>{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        /* ── DESKTOP BENTO GRID VIEW (Rich Animated Bento Layout) ── */
        <TestimonialsBento />
      )}
    </section>
  );
}
